<div class="main-content">
  <div class="position-relative">
    <tabset #staticTabs type="tabs game-nav-bar">
      <tab heading="Inplay" (selectTab)="onMainSelectRoute('home')">

        <div id="home" class="tab-pane sports scrollHeight" >
          <tabset #staticSubTabs type="tabs game-nav-bar">
            <tab *ngFor="let mn of menuItems; let i=index;trackBy:trackByIndex;" (selectTab)="onSelect(mn)">
              
              <div class="filter-ct" *ngIf="!events.races.includes(mn.id) && !events.casino.includes(mn.id)">
                <label>View by:</label>
                <select class="form-control-sm" [(ngModel)]="viewBy">
                  <option value="c">Competitions</option>
                  <option value="t">Time</option>
                </select>
              </div>

              <ng-template tabHeading>
                <div><img src="https://speedcdn.io/assets/diamond-client-v8/{{mn.id}}.png" alt=""> </div>
                <div [ngClass]="{'new-tag-menus': (events.binary.includes(mn?.id))}">{{mn.name}}<em>new</em></div>
              </ng-template>
              

              <!-- tab-content -->
              <app-m-sport-list *ngIf="tabId == mn.id && !events.casino.includes(mn.id)" [viewBy]="viewBy" [list]="inPlayData" [eventId]="mn.id" [oddsData]="oddsLisDis"></app-m-sport-list>
              <!-- /tab-content -->

              <app-loader *ngIf="isLoad" [isFpLoader]="false"></app-loader>
            </tab>
          </tabset>
        </div>
      </tab>
      <tab heading="Sports" (selectTab)="onMainSelectRoute('sports')">

        <div id="home" class="tab-pane sports" *ngIf="mainTabId == 1">
          <tabset #staticSubTabsSp type="tabs game-nav-bar">
            <tab id="goto-sports-{{i}}" *ngFor="let mn of menuItems; let i=index;trackBy:trackByIndex;" (selectTab)="onSelect(mn)">
              <ng-template tabHeading>
                <div><img src="https://speedcdn.io/assets/diamond-client-v8/{{mn.id}}.png" alt=""></div>
                <div [ngClass]="{'new-tag-menus': (events.binary.includes(mn?.id))}">{{mn.name}} <em>new</em></div>
              </ng-template> 

              <div class="filter-ct" *ngIf="!events.races.includes(mn.id) && !events.casino.includes(mn.id)">
                <label>View by:</label>
                <select class="form-control-sm" [(ngModel)]="viewBy">
                  <option value="c">Competitions</option>
                  <option value="t">Time</option>
                </select>
              </div>

              <!-- tab-content -->
              <app-m-sport-list *ngIf="tabId == mn.id && !events.casino.includes(mn.id)" [viewBy]="viewBy" [list]="data" [eventId]="mn.id" [oddsData]="oddsLisDis"></app-m-sport-list>
              <!-- /tab-content -->

              <app-loader *ngIf="isLoad" [isFpLoader]="false"></app-loader>
            </tab>
          </tabset>
        </div>
      </tab>
      <tab heading="Casino + slot" (selectTab)="onMainSelectRoute('slot')">

        <div id="home" class="tab-pane sports">
          <tabset #casinoTabs type="tabs game-nav-bar">
            <tab *ngFor="let mn of menuItems; let i=index;trackBy:trackByIndex;" (selectTab)="onSelect(mn)">
              <ng-template tabHeading>
                <div><img src="https://speedcdn.io/assets/diamond-client-v8/{{mn.id}}.png" alt=""> </div>
                <div>
                  {{mn.name}}
                  <!-- {{eventsName[mn.id]}} -->
                </div>
              </ng-template> 

              <!-- tab-content -->
              <app-m-casino *ngIf="tabId == mn.id && (events.casino.includes(mn.id))" [gameId]="mn.id"></app-m-casino>
              <!-- /tab-content -->

            </tab>
          </tabset>
        </div>
      
      </tab>
      <!-- <tab customClass="customClass" (selectTab)="onMainSelectRoute('sports-book')">

        <ng-template tabHeading>
          <div class="new-tag-menus-sb">Sports book <em>new</em></div>
        </ng-template>
        <div class="container">
        </div>
      </tab> -->
      <tab heading="Others" (selectTab)="onMainSelectRoute('others')">
        <div class="container" *ngIf="mainTabId == 3">
          <div class="row my-2">
            <div class="col-12">
              <img class="img-fluid mb-2" src="https://speedcdn.io/assets/diamond-client-v8/poster-binary.jpg" (click)="redirectToListAfterCheck(99990)">
              <img class="img-fluid mb-2" src="https://speedcdn.io/assets/diamond-client-v8/poster-election.jpg" (click)="redirectToListAfterCheck(2378961)">
            </div>
          </div>
        </div>
      </tab>
    </tabset>

    <!-- Casino Tables content  -->
    <div class="tab-content" *ngIf="mainTabId == 0 && casinoData.length > 0">
      <div class="tab-pane active casino-tables">
        <div class="container-fluid">
          <div class="row row5">
            <div class="col-12">
              <h4 class="text-uppercase mt-2">Our Casino</h4>
            </div>
          </div>
          <div class="row row5 mt-1">
            <div class="col-3 text-center">
              <div class="casinoicons">
                <a href="javascript:void(0)" (click)="redirectCasinoDetail(99995, 883)">
                  <img src="https://speedcdn.io/assets/diamond-client-v8/casino/aviator-animate.gif" class="img-fluid">
                  <div class="casino-name">Aviator</div>
                </a>
              </div>
            </div>
            <div class="col-3 text-center" *ngFor="let item of casinoData;trackBy:trackByIndex;">
              <div class="casinoicons">
                <a href="javascript:void(0)" [routerLink]="env.isMobile ? ['/m/casino-detail', 99999, item.id] : ['/casino-detail', 99999, item?.id]" class="">
                  <img *ngIf="!domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/casinogames-new-v1/{{item?.id}}.webp" class="img-fluid"> 
                  <img *ngIf="domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/casinogames-new-video/{{item?.id}}.gif" class="img-fluid"> 
                  <div class="casino-name">{{item?.name}}</div>
                  <!-- <div class="new-launch-casino">New Launch</div> -->
                </a>
              </div>
            </div>
            <div class="col-3 text-center">
              <div class="casinoicons">
                <a href="javascript:void(0)" (click)="redirectCasino('99995:royal-gaming')">
                  <img *ngIf="!domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/diamond-client-v8/casino/rg.jpg" class="img-fluid"> 
                  <img *ngIf="domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/casinogames-new-video/rg.gif" class="img-fluid"> 
                  <div class="casino-name">Royal Gaming</div>
                </a>
              </div>
            </div>

            <div class="col-3 text-center">
              <div class="casinoicons">
                <a href="javascript:void(0)" (click)="redirectCasino('99995:evolution-gaming')">
                  <img *ngIf="!domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/diamond-client-v8/casino/evolutions.jpg" class="img-fluid">
                  <img *ngIf="domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/casinogames-new-video/evolutions.gif" class="img-fluid">
                  <div class="casino-name">Evolution Gaming</div>
                </a>
              </div>
            </div>

            <div class="col-3 text-center">
              <div class="casinoicons">
                <a href="javascript:void(0)" (click)="redirectCasino('99995:onetouch')">
                  <img *ngIf="!domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/diamond-client-v8/casino/onetouch.jpg" class="img-fluid">
                  <img *ngIf="domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/casinogames-new-video/onetouch.gif" class="img-fluid">
                  <div class="casino-name">One Touch</div>
                </a>
              </div>
            </div>

            <div class="col-3 text-center">
              <div class="casinoicons">
                <a href="javascript:void(0)" (click)="redirectCasino('99995:ae-sexy')">
                  <img *ngIf="!domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/diamond-client-v8/casino/aesexy.jpg" class="img-fluid">
                  <img *ngIf="domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/casinogames-new-video/aesexy.gif" class="img-fluid">
                  <div class="casino-name">AE Sexy</div>
                </a>
              </div>
            </div>

            <div class="col-3 text-center">
              <div class="casinoicons">
                <a href="javascript:void(0)" (click)="redirectCasino('99995:betgamestv')">
                  <img *ngIf="!domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/diamond-client-v8/casino/betgames.jpg" class="img-fluid">
                  <img *ngIf="domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/casinogames-new-video/betgames.gif" class="img-fluid">
                  <div class="casino-name">Bet Games</div>
                </a>
              </div>
            </div>

            <div class="col-3 text-center">
              <div class="casinoicons">
                <a href="javascript:void(0)" (click)="redirectCasino('99995:bombay-live')">
                  <img *ngIf="!domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/diamond-client-v8/casino/bombaylive.jpg" class="img-fluid">
                  <img *ngIf="domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/casinogames-new-video/bombaylive.gif" class="img-fluid">
                  <div class="casino-name">Bombay Live</div>
                </a>
              </div>
            </div>

            <div class="col-3 text-center">
              <div class="casinoicons">
                <a href="javascript:void(0)" (click)="redirectCasino('99995:ezugi')">
                  <img *ngIf="!domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/diamond-client-v8/casino/ezugi.jpg" class="img-fluid">
                  <img *ngIf="domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/casinogames-new-video/ezugi.gif" class="img-fluid">
                  <div class="casino-name">Ezugi</div>
                </a>
              </div>
            </div>

            <div class="col-3 text-center">
              <div class="casinoicons">
                <a href="javascript:void(0)" (click)="redirectCasino('99995:gamzix')">
                  <img *ngIf="!domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/diamond-client-v8/casino/gamezix.jpg" class="img-fluid">
                  <img *ngIf="domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/casinogames-new-video/gamezix.gif" class="img-fluid">
                  <div class="casino-name">Gamezix</div>
                </a>
              </div>
            </div>

            <div class="col-3 text-center">
              <div class="casinoicons">
                <a href="javascript:void(0)" (click)="redirectCasino('99995:jili-gaming')">
                  <img *ngIf="!domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/diamond-client-v8/casino/jili.jpg" class="img-fluid">
                  <img *ngIf="domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/casinogames-new-video/jili.gif" class="img-fluid">
                  <div class="casino-name">Jili</div>
                </a>
              </div>
            </div>

            <div class="col-3 text-center">
              <div class="casinoicons">
                <a href="javascript:void(0)" (click)="redirectCasino('99995:kingmaker')">
                  <img *ngIf="!domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/diamond-client-v8/casino/kingmaker.jpg" class="img-fluid">
                  <img *ngIf="domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/casinogames-new-video/kingmaker.gif" class="img-fluid">
                  <div class="casino-name">Kingmaker</div>
                </a>
              </div>
            </div>
            
          </div>
          
        </div>
      </div>
    </div>
    <!--/ Casino Tables content End -->

  </div>

</div>